import React, { Component } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import './Rooms.css';

import roomCh1 from '../assets/imgs/rooms-ch1.png';

class Chapter1 extends Component {
    render() {
        return (
            <div className="Rooms" ref={(div) => (this.appContainer = div)}>
                <Header />
                <div className="Rooms-container">
                    <div className="Room-top"></div>
                    <div className="Room-mid">
                        <div className="Room-header">THE BUNKER</div>
                        <hr />
                        <div className="Room-img">
                            <img src={roomCh1} alt="" />
                        </div>
                        <div className="Room-description">
                            <div className="text">
                                You found your way to The Bunker to seek shelter, but your group has
                                been spotted by the vandals and are now tracking you. You must find
                                the map to the UHC (United Human Compound) hidden in the Bunker
                                before Lightcrawler’s pack does.
                                <p>This game involves a live actor.</p>
                            </div>
                            <div className="table-container">
                                <div className="table-row">
                                    <div className="table-label">MISSION</div>
                                    <div className="table-text">
                                        Find the map and escape before the vandals catch up to you.
                                    </div>
                                </div>
                                <div className="table-row">
                                    <div className="table-label">TIME</div>
                                    <div className="table-text">50 min</div>
                                </div>
                                <div className="table-row">
                                    <div className="table-label">PLAYERS</div>
                                    <div className="table-text">Min 2, Max 8</div>
                                </div>
                                <div className="table-row">
                                    <div className="table-label">DIFFICULTY</div>
                                    <div className="table-text">
                                        <span className="fa fa-star checked"></span>
                                        <span className="fa fa-star checked"></span>
                                        <span className="fa fa-star checked"></span>
                                        <span className="fa fa-star checked"></span>
                                        <span className="fa fa-star"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="note">
                                * If you desire to book a specific game that is not reflected on our
                                Ticket Schedule please contact us for further availability. <br />*
                                You can swap Chapters. If for a desired time slot you would prefer
                                to do another Chapter
                                <br /> that is originally offered on our Ticketing Site, please
                                contact us to swap for your preferred Chapter.
                            </div>
                        </div>
                    </div>
                    <div className="Room-bottom"></div>
                </div>

                <Footer />
            </div>
        );
    }
}

export default Chapter1;
